export default __webpack_public_path__ + "static/media/androidQRCode.6e8da3ef.svg";